import React, { useMemo } from 'react'

import dayjs from 'dayjs'
import toast from 'react-hot-toast'

import { parseDate } from './ChallengesList'
import { Input, Section, SectionSubtitle } from '../..'
import { useChallenge, useUser } from '../../../context'
import { useStudents } from '../../../hooks/useStudents'
import { ChallengeStatus, ChallengeVisibility } from '../../../types'
import {
  capitalizeFirstLetter,
  translateStatus,
} from '../../../utilFunctions/transformFunc'
import Preview from '../../Cards/ChallengeCards/ChaPreviewCard'
import { PreviewBadge } from '../../Cards/ChallengeCards/styles'
import {
  FieldRow,
  Layout,
  LeftColumn,
  RightColumn,
} from '../../forms/ChallengeForm/style'

import {
  CheckboxField,
  CounterContainer,
  ListContainer,
  ListItem,
  Photo,
} from './styles'

const ParticipantsList = () => {
  const { formState, updateParticipant, error: chaError } = useChallenge()
  const { students } = useStudents()
  const { userRole } = useUser()

  const computeStatus = useMemo(() => {
    const start = parseDate(formState.startDate)
    const end = parseDate(formState.endDate)
    const today = dayjs().startOf('day')

    if (start?.isValid() && today.isBefore(start, 'day')) {
      return ChallengeStatus.UPCOMING
    }
    if (end?.isValid() && today.isAfter(end, 'day')) {
      return ChallengeStatus.ENDED
    }
    return ChallengeStatus.ACTIVE
  }, [formState.startDate, formState.endDate])

  const badgeLabel = useMemo(() => {
    return translateStatus(computeStatus)
  }, [computeStatus])

  const handleUpdate = async (studentId: string) => {
    try {
      const res = await updateParticipant(studentId)

      toast.success(res?.message ?? 'Participante agregado')
    } catch (error) {
      console.log(error)
      toast.error(chaError)
    }
  }
  return (
    <Section
      title="Participantes"
      childrenClass="full-space-section"
      style={{ overflowY: 'scroll', paddingBottom: 0 }}
      withBackBtn={true}
      backURL="/desafios"
    >
      <Layout>
        <RightColumn style={{ paddingLeft: 20 }}>
          <SectionSubtitle fontSize={16} fontWeight={600}>
            <CounterContainer>
              <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                {userRole === 'admin' && (
                  <PreviewBadge
                    $status={computeStatus}
                    $visibility={formState.visibility}
                    className="visibility"
                  >
                    {capitalizeFirstLetter(
                      formState.visibility
                        ? ChallengeVisibility.VISIBLE
                        : ChallengeVisibility.HIDDEN,
                    )}
                  </PreviewBadge>
                )}
                <PreviewBadge
                  $status={computeStatus}
                  $visibility={formState.visibility}
                  className="status"
                >
                  {badgeLabel}
                </PreviewBadge>
                <p>{formState.title}</p>
              </div>

              <p className="subtitle">Ah-plausos: {formState.points} puntos</p>
            </CounterContainer>
          </SectionSubtitle>
          <FieldRow>
            <ListContainer>
              {students.map((student) => {
                return (
                  <ListItem key={student.uid}>
                    <Photo
                      $img={student.image || '/assets/profile.png'}
                      aria-label={student.name}
                    />
                    <CheckboxField
                      id="participants"
                      label={`${capitalizeFirstLetter(student.name)} ${capitalizeFirstLetter(student.lastname)}`}
                    >
                      <Input
                        id={student.uid}
                        name="participants"
                        checked={formState.participants.includes(student.uid)}
                        type="checkbox"
                        onChange={() => handleUpdate(student.uid)}
                        disabled={computeStatus === ChallengeStatus.UPCOMING}
                      />
                    </CheckboxField>
                  </ListItem>
                )
              })}
            </ListContainer>
          </FieldRow>

          <CounterContainer>
            <p>Participantes totales</p>
            <p>
              {formState.participants.length - 1 <= 0
                ? '0'
                : formState.participants.length - 1}
            </p>
          </CounterContainer>
        </RightColumn>
        <LeftColumn>
          <Preview />
        </LeftColumn>
      </Layout>
    </Section>
  )
}

export default ParticipantsList
